import * as React from "react";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { MetricGrid, type MetricGridItem } from "@/components/dashboard/MetricGrid";

interface VersionCardProps {
  metrics: MetricGridItem[];
}

/** Thin `StatusCard` + `MetricGrid` composition for the System page's Application section - mirrors Sprint 3.5's `AnalyticsSummaryPanel` precedent for a per-page named panel. */
export function VersionCard({ metrics }: VersionCardProps): React.JSX.Element {
  return (
    <StatusCard title="Application">
      <MetricGrid metrics={metrics} />
    </StatusCard>
  );
}
